import Main from './components/Main'

import './styles/commonStyles.scss'

window.Vnda = { ...window.Vnda, Component: { ...window.Vnda?.Component } }
window.Vnda.Component[COMPONENT_NAME] = Main
